export const AVATAR_TYPES = ['default', 'initials', 'image'] as const;
export type AvatarType = (typeof AVATAR_TYPES)[number];

export const BOT_INITIALS = 'AI';
export const BOT_NAME = 'AI Assistant';
export const DEFAULT_AVATAR_TYPE: AvatarType = 'default';

export const isAvatarType = (value: string): value is AvatarType => (AVATAR_TYPES as readonly string[]).includes(value);
export const DEFAULT_PRIMARY_COLOR = '#618025';
export const DEFAULT_TEXT_COLOR = '#FFFFFF';

export const getAvatarInitials = (name: string): string => {
    const words = name.trim().split(/\s+/);
    if (words.length >= 2) {
        return (words[0][0] + words[1][0]).toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
};
